import { Fragment, useRef, useState } from "react";
import "./RightClickMenu.scss";

export const RIGHT_CLICK_MENU_CONTROLLER = {
    showRightClickMenu: (e, items = null, onCloseCallback) => {
        console.warn("Right click menu controller not initialized. Please ensure RightClickMenu component is mounted.");
    },
    refreshRightClickMenu: (items = null) => {
        console.warn("Right click menu controller not initialized. Please ensure RightClickMenu component is mounted.");
    },
    hideRightClickMenu: () => {
        console.warn("Right click menu controller not initialized. Please ensure RightClickMenu component is mounted.");
    },
}

export const DEFAULT_RIGHT_CLICK_MENU = [
    { label: "Copy", action: (e) => {console.log("Copy clicked"); RIGHT_CLICK_MENU_CONTROLLER.hideRightClickMenu();} },
    { label: "Paste", action: (e) => {console.log("Paste clicked"); RIGHT_CLICK_MENU_CONTROLLER.hideRightClickMenu();} },
    { label: "Delete", action: (e) => {console.log("Delete clicked"); RIGHT_CLICK_MENU_CONTROLLER.hideRightClickMenu();} },
    { label: "Edit", action: (e) => {console.log("Edit clicked"); RIGHT_CLICK_MENU_CONTROLLER.hideRightClickMenu();} }
]

const RightClickMenu = () => {
    const [rightClickMenuActive, setRightClickActive] = useState(false);
    const [onCloseCallback, setOnCloseCallback] = useState(null);

    const [rightClickMenuPosition, setRightClickMenuPosition] = useState({ x: 0, y: 0 });
    const [rightClickMenuItems, setRightClickMenuItems] = useState(DEFAULT_RIGHT_CLICK_MENU);

    const showRightClickMenu = (e, items = null, onCloseCallback = null) => {
        e.preventDefault();
        e.stopPropagation();
        
        // When setting menu position, we need to ensure it doesn't go off-screen
        // So, when on the left we use left: mouseX, and when on the right we use right: window.innerWidth - mouseX
        // Same for top and bottom
        const mouseX = e.clientX;
        const mouseY = e.clientY;
        const clickPosition = {};
        if (mouseX < window.innerWidth / 2) {
            clickPosition.left = mouseX;
        } else {
            clickPosition.right = window.innerWidth - mouseX;
        }
        if (mouseY < window.innerHeight / 2) {
            clickPosition.top = mouseY;
        } else {
            clickPosition.bottom = window.innerHeight - mouseY;
        }
        setRightClickMenuPosition(clickPosition);

        setRightClickMenuItems(items);
        setOnCloseCallback(() => onCloseCallback);
        setRightClickActive(true);
    }

    const hideRightClickMenu = () => {
        setRightClickActive(false);
        setRightClickMenuPosition({ x: 0, y: 0 });
        if (onCloseCallback) {
            onCloseCallback();
        }
    }

    const refreshRightClickMenu = (items = null) => {
        if (!rightClickMenuActive) {
            return;
        }

        if (items) {
            setRightClickMenuItems(items);
        }
    }

    RIGHT_CLICK_MENU_CONTROLLER.showRightClickMenu = showRightClickMenu;
    RIGHT_CLICK_MENU_CONTROLLER.refreshRightClickMenu = refreshRightClickMenu;
    RIGHT_CLICK_MENU_CONTROLLER.hideRightClickMenu = hideRightClickMenu;

    const options = [[]];
    let column = 0;
    for (let i = 0; i < rightClickMenuItems.length; i++) {
        if (options[column].length >= 10) {
            column++;
            options.push([]);
        }
        options[column].push(rightClickMenuItems[i]);
    }

    return (
        <>
            {rightClickMenuActive &&
                <div className="right-click-menu-holder" onClick={hideRightClickMenu} onContextMenu={(e) => e.preventDefault()}>
                    <div className="right-click-menu-positioner">
                        <div className="right-click-menu" style={rightClickMenuPosition}>
                            {rightClickMenuItems && options.map((columnItems, columnIndex) => (
                                <div key={columnIndex} className="right-click-menu-column">
                                    {columnItems.map((item, index) => (
                                        <div
                                            key={index}
                                            className={`right-click-menu-item${!item.disabled && item.action && (item.clickable || typeof item.clickable === "undefined") ? " clickable" : ""}${item.disabled ? " disabled" : ""}`}
                                            onClick={item.action ? (e) => {
                                                e.stopPropagation();
                                                item.action(e);
                                            } : null}
                                        >
                                            {item.label}
                                        </div>
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default RightClickMenu;
